import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.59,
			d: "M7892.31 2655.78h640v768h-640z",
			transform: "matrix(1 0 0 1.12682 -7700.31 -2913.29)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M64 944.7h896M320 214.7h64v64h-64zM320 406.7h64v64h-64zM320 598.7h64v64h-64zM640 214.7h64v64h-64zM640 406.7h64v64h-64zM640 598.7h64v64h-64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 37.77,
			d: "M8020.31 2783.78h64v64h-64z",
			transform: "matrix(1 0 0 2.50321 -7540.31 -6183.9)"
		})
	]
});
export default SvgIconBuilding;
